export default "__VITE_ASSET__DlShR_Ff__"